import Immutable from 'immutable';
import React, { ReactElement } from 'react';
import { Submittal, SubmittalId } from 'records/Submittal';
import SubmittalLogRow from './SubmittalLogRow';

const SubmittalLogRenderer = (
  index: number,
  style: React.CSSProperties,
  data: any,
  selectedSubmittals: Immutable.Set<string>,
  openSubmittal: SubmittalId,
  onSubmittalClick: (submittal: Submittal) => void,
  handleSubmittalChecked: (submittal: Submittal) => void
): ReactElement => {
  const submittal = data.valueSeq().get(index);

  return (
    <SubmittalLogRow
      style={style}
      key={submittal.id}
      submittal={submittal}
      selectedSubmittals={selectedSubmittals}
      openSubmittal={openSubmittal}
      onSubmittalClick={() => onSubmittalClick(submittal)}
      handleSubmittalChecked={() => handleSubmittalChecked(submittal)}
    />
  );
};

export default SubmittalLogRenderer;
